import React, { useState, Fragment, useEffect } from 'react';
import { useForm, FormContext } from 'react-hook-form';
import { useStyle } from './style';
import EirPersonalInformation from './EirPersonalInformation';
import EirCustomerAccountDetails from './EirCustomerAccountDetails';
import {
	Paper, Grid, Box,
	Typography, Button,
	Stepper, Step, StepLabel
} from '@material-ui/core';
import EirCustomerMarketingPreferences from './EirCustomerMarketingPreference';
import EirContactDetails from './EirContactDetails';
import EirCustomerMobileDetails from './EirCustomerMobileDetails';
import { makeStyles, withStyles, createMuiTheme, ThemeProvider } from '@material-ui/core/styles';
import { theme } from './theme';
import axios from 'axios';
import StepConnector from '@material-ui/core/StepConnector';
import { isMobileOnly } from 'react-device-detect';
import clsx from 'clsx';
import { Icon } from '@material-ui/core';
import EirLogin from '../eir-login/EirLogin';
import { Modal, ModalBody } from 'reactstrap';
import EirCustomerAddress from './EirCustomerAddress';

export default function EirCustomerDetailsContainer(props) {
	const { handleSubmit, errors, control } = useForm();
	const [showEirCustomerMobileDetails, setShowEirCustomerMobileDetails] = useState(false);
	const [showSIMOMobileDetails, setShowSIMOMobileDetails] = useState(false);
	const [SIMOName, setSIMOName] = useState(null);
	const classes = useStyle();
	const [mailConfirmation, setMailConfirmation] = useState(true);
	const onSubmit = (data, mailConfirmation) => {

		let isError = false;
		if (Object.keys(methods.errors).length > 0) {
			isError = true;
			Object.keys(methods.errors).forEach((item) => {
				methods.setError(item, methods.errors[item].type, methods.errors[item].message);
			});
		}
		if (!isError) {
			saveCustomerDetails(data, mailConfirmation);
		}

	};
	async function saveCustomerDetails(data, mailConfirmation) {
		setMailConfirmation(true);
		if (data.email != data.confEmail) {
			setMailConfirmation(false);
			return;
		}
		var bodyFormData = new FormData();
		if (data.prefix)
			bodyFormData.append('existingEirPhoneNumberPrefix', data.prefix);
		else
			bodyFormData.append('existingEirPhoneNumberPrefix', '');

		if (data.eirPhoneNo)
			bodyFormData.append('existingEirPhoneNumber', data.eirPhoneNo);
		else
			bodyFormData.append('existingEirPhoneNumber', '');
		if (data.eirAccountNo)
			bodyFormData.append('existingEirAccountNumber', data.eirAccountNo);
		else
			bodyFormData.append('existingEirAccountNumber', '');
		bodyFormData.append('title', data.title);
		bodyFormData.append('firstName', data.firstName);
		bodyFormData.append('lastName', data.lastName);
		bodyFormData.append('email', data.email);
		bodyFormData.append('emailConfirm', data.confEmail);
		if (data.mobile) {
			bodyFormData.append('mobilePrefix', data.mobile.substring(0, 3));
			bodyFormData.append('mobileNumber', data.mobile.substring(3, 10));
		}
		bodyFormData.append('contactMethod', data.preContact);
		/*Different address part start*/
		if (localStorage.getItem('eir_be_data')) {
			let order = JSON.parse(localStorage.getItem('eir_be_data')).order;
			if ((localStorage.getItem('eir_prequal_data')) || (localStorage.getItem('ACQ_PREQUAL_RESULT'))) {
			 let addressLine1 = JSON.parse(localStorage.getItem('ACQ_PREQUAL_RESULT')).addressResponse.addressLine1 ? 
				JSON.parse(localStorage.getItem('ACQ_PREQUAL_RESULT')).addressResponse.addressLine1 : 
				JSON.parse(localStorage.getItem('eir_prequal_data')).addressLine1;
				let addressLine2 = JSON.parse(localStorage.getItem('ACQ_PREQUAL_RESULT')).addressResponse.addressLine2 ? 
				JSON.parse(localStorage.getItem('ACQ_PREQUAL_RESULT')).addressResponse.addressLine2 : 
				JSON.parse(localStorage.getItem('eir_prequal_data')).addressLine2;
				let addressLine3 = JSON.parse(localStorage.getItem('ACQ_PREQUAL_RESULT')).addressResponse.addressLine3 ? 
				JSON.parse(localStorage.getItem('ACQ_PREQUAL_RESULT')).addressResponse.addressLine3 : 
				JSON.parse(localStorage.getItem('eir_prequal_data')).addressLine3;
				if (order.prequal && order.prequal.fullAddress) {
					let fullAddress = (order.prequal.fullAddress);
					const addressArray = fullAddress.split(',');
					let arrLength = addressArray.length;
					let add1 = '';
					if (arrLength === 2)
						add1 = add1.concat(addressArray[0]);
					else {
						for (let i = 0; i < (arrLength - 2); i++) {
							add1 = add1.concat(addressArray[i]);
							add1 = add1.concat(',');
						}
					}
					/*****************Billing address from prequal address start***********************/
					//bodyFormData.append('billingAddress.address1', add1);
					bodyFormData.append('billingAddress.address1', addressLine1);
					bodyFormData.append('billingAddress.address2', addressLine2);
					bodyFormData.append('billingAddress.address3', addressLine3);
					if (localStorage.getItem('ls_district'))
						bodyFormData.append('billingAddress.town', localStorage.getItem('ls_district'));
					else
						bodyFormData.append('billingAddress.town', '');
					if (localStorage.getItem('ls_county'))
						bodyFormData.append('billingAddress.county', getCounty(localStorage.getItem('ls_county')));
					else
						bodyFormData.append('billingAddress.county', '');

					/**get EIRCODE value */
					if (eirCode != null) {//first check eircode from prequal
						bodyFormData.append('billingAddress.eircode', eirCode);
					} else if (data.custEircode) {// checking from input value
						bodyFormData.append('billingAddress.eircode', data.custEircode);
					} else//default value
						bodyFormData.append('billingAddress.eircode', '');
					/*****************Billing address from prequal address end***********************/
					if (data.sameDeliveryAddress) {//if billing and delivery is same and taken from prequal address
						bodyFormData.append('deliverToSameAddress', true);
						bodyFormData.append('deliveryAddress.address1', add1);
						if (localStorage.getItem('ls_district'))
							bodyFormData.append('deliveryAddress.town', localStorage.getItem('ls_district'));
						else
							bodyFormData.append('deliveryAddress.town', '');
						if (localStorage.getItem('ls_county'))
							bodyFormData.append('deliveryAddress.county', getCounty(localStorage.getItem('ls_county')));
						else
							bodyFormData.append('deliveryAddress.county', '');

						/**get EIRCODE value */
						if (eirCode != null) {//first check eircode from prequal
							bodyFormData.append('billingAddress.eircode', eirCode);
							bodyFormData.append('deliveryAddress.eircode', eirCode);
						} else if (data.custEircode) {// checking from input value
							bodyFormData.append('billingAddress.eircode', data.custEircode);
							bodyFormData.append('deliveryAddress.eircode', data.custEircode);
						} else {//default value
							bodyFormData.append('billingAddress.eircode', '');
							bodyFormData.append('deliveryAddress.eircode', '');
						}
					} else {
						if (data.deliveryAddressaddressLine1) {
							bodyFormData.append('deliverToSameAddress', false);
							bodyFormData.append('deliveryAddress.eircode', data.deliveryAddressEirCode);
							bodyFormData.append('deliveryAddress.address1', data.deliveryAddressaddressLine1);
							bodyFormData.append('deliveryAddress.address2', data.deliveryAddressaddressLine2);
							bodyFormData.append('deliveryAddress.address3', data.deliveryAddressaddressLine3);
							bodyFormData.append('deliveryAddress.town', data.deliveryAddresstown);
							bodyFormData.append('deliveryAddress.county', getCounty(data.deliveryAddresscounty));
						}
						else {
							bodyFormData.append('deliverToSameAddress', true);
							bodyFormData.append('deliveryAddress.address1', add1);
							if (localStorage.getItem('ls_district'))
								bodyFormData.append('deliveryAddress.town', localStorage.getItem('ls_district'));
							else
								bodyFormData.append('deliveryAddress.town', '');
							if (localStorage.getItem('ls_county'))
								bodyFormData.append('deliveryAddress.county', getCounty(localStorage.getItem('ls_county')));
							else
								bodyFormData.append('deliveryAddress.county', '');

							if (eirCode != null) {//first check eircode from prequal
								bodyFormData.append('billingAddress.eircode', eirCode);
								bodyFormData.append('deliveryAddress.eircode', eirCode);
							} else if (data.custEircode) {// checking from input value
								bodyFormData.append('billingAddress.eircode', data.custEircode);
								bodyFormData.append('deliveryAddress.eircode', data.custEircode);
							} else {//default value
								bodyFormData.append('billingAddress.eircode', '');
								bodyFormData.append('deliveryAddress.eircode', '');
							}
						}
					}
				}
			} else {
				if (!data.sameDeliveryAddress) {//if billing and delivery is different address
					bodyFormData.append('deliverToSameAddress', (JSON.parse(localStorage.getItem('eir_be_data')).order.prequal) ? true : false);
					/*billing address*/
					bodyFormData.append('billingAddress.eircode', data.billingAddressEirCode);
					bodyFormData.append('billingAddress.address1', data.billingAddressaddressLine1);
					bodyFormData.append('billingAddress.address2', data.billingAddressaddressLine2);
					bodyFormData.append('billingAddress.address3', data.billingAddressaddressLine3);
					bodyFormData.append('billingAddress.town', data.billingAddresstown);
					bodyFormData.append('billingAddress.county', getCounty(data.billingAddresscounty));
					/*delivery address*/
					bodyFormData.append('deliveryAddress.eircode', (JSON.parse(localStorage.getItem('eir_be_data')).order.prequal) ? data.billingAddressEirCode : data.deliveryAddressEirCode);
					bodyFormData.append('deliveryAddress.address1', (JSON.parse(localStorage.getItem('eir_be_data')).order.prequal) ? data.billingAddressaddressLine1 : data.deliveryAddressaddressLine1);
					bodyFormData.append('deliveryAddress.address2', (JSON.parse(localStorage.getItem('eir_be_data')).order.prequal) ? data.billingAddressaddressLine2 : data.deliveryAddressaddressLine2);
					bodyFormData.append('deliveryAddress.address3', (JSON.parse(localStorage.getItem('eir_be_data')).order.prequal) ? data.billingAddressaddressLine3 : data.deliveryAddressaddressLine3);
					bodyFormData.append('deliveryAddress.town', (JSON.parse(localStorage.getItem('eir_be_data')).order.prequal) ? data.billingAddresstown : data.deliveryAddresstown);
					bodyFormData.append('deliveryAddress.county', (JSON.parse(localStorage.getItem('eir_be_data')).order.prequal) ? getCounty(data.billingAddresscounty) : getCounty(data.deliveryAddresscounty));
				} else {//same address for both
					bodyFormData.append('deliverToSameAddress', true);
					/*billing address*/
					bodyFormData.append('billingAddress.eircode', data.billingAddressEirCode);
					bodyFormData.append('billingAddress.address1', data.billingAddressaddressLine1);
					bodyFormData.append('billingAddress.address2', data.billingAddressaddressLine2);
					bodyFormData.append('billingAddress.address3', data.billingAddressaddressLine3);
					bodyFormData.append('billingAddress.town', data.billingAddresstown);
					bodyFormData.append('billingAddress.county', getCounty(data.billingAddresscounty));
					/*delivery address*/
					bodyFormData.append('deliveryAddress.eircode', data.billingAddressEirCode);
					bodyFormData.append('deliveryAddress.address1', data.billingAddressaddressLine1);
					bodyFormData.append('deliveryAddress.address2', data.billingAddressaddressLine2);
					bodyFormData.append('deliveryAddress.address3', data.billingAddressaddressLine3);
					bodyFormData.append('deliveryAddress.town', data.billingAddresstown);
					bodyFormData.append('deliveryAddress.county', getCounty(data.billingAddresscounty));
				}
				/*Different address part finish*/
			}
	}
		bodyFormData.append('gender', 'fake');
		bodyFormData.append('dobDay', data.date);
		bodyFormData.append('dobMonth', data.month);
		bodyFormData.append('dobYear', data.year);
		bodyFormData.append('nationality', 'fake');
		if (data.residential)
			bodyFormData.append('residentialStatus', data.residential);
		else
			bodyFormData.append('residentialStatus', 'N/A');
		if (data.addressProof)
			bodyFormData.append('proofOfAddress', data.addressProof);
		else
			bodyFormData.append('proofOfAddress', 'N/A');
		bodyFormData.append('yearsAtAddress', 'fake');
		if (data.idType)
			bodyFormData.append('idType', data.idType);
		else
			bodyFormData.append('idType', 'N/A');
		if (data.idNumber)
			bodyFormData.append('idNumber', data.idNumber);
		else
			bodyFormData.append('idNumber', 'N/A');
		bodyFormData.append('occupationStatus', 'fake');
		if (data.occupationType)
			bodyFormData.append('occupationType', data.occupationType);
		else
			bodyFormData.append('occupationType', 'N/A');
		bodyFormData.append('yearsWithEmployer', 'fake');


		if (data.permissionGroupList)
			var permissionGroupList = JSON.parse(data.permissionGroupList);

		if (data.permissionGroupList && permissionGroupList[0].enabled) {//during market preference
			permissionGroupList[0].preferenceList.filter(preference => preference.name === 'Email').map((data) =>
				bodyFormData.append('allowMarketingEmail', data.enabled)
			)
			permissionGroupList[0].preferenceList.filter(preference => preference.name === 'SMS').map((data) =>
				bodyFormData.append('allowMarketingSms', data.enabled)
			)
			permissionGroupList[0].preferenceList.filter(preference => preference.name === 'Phone').map((data) =>
				bodyFormData.append('allowMarketingPhone', data.enabled)
			)
			permissionGroupList[0].preferenceList.filter(preference => preference.name === 'Door to door').map((data) =>
				bodyFormData.append('allowMarketingFots', data.enabled)
			)
			permissionGroupList[0].preferenceList.filter(preference => preference.name === 'Direct mail').map((data) =>
				bodyFormData.append('allowMarketingMail', data.enabled)
			)
		} else {//during market preference
			bodyFormData.append('allowMarketingEmail', false);
			bodyFormData.append('allowMarketingSms', false);
			bodyFormData.append('allowMarketingPhone', false);
			bodyFormData.append('allowMarketingFots', false);
			bodyFormData.append('allowMarketingMail', false);
		}
		// if (data.permissionGroupList && permissionGroupList[1].enabled) {//after market preference
		// 	permissionGroupList[1].preferenceList.filter(preference => preference.name === 'Email').map((data) =>
		// 		bodyFormData.append('allowMarketingEmailAfter', data.enabled)
		// 	)
		// 	permissionGroupList[1].preferenceList.filter(preference => preference.name === 'SMS').map((data) =>
		// 		bodyFormData.append('allowMarketingSmsAfter', data.enabled)
		// 	)
		// 	permissionGroupList[1].preferenceList.filter(preference => preference.name === 'Phone').map((data) =>
		// 		bodyFormData.append('allowMarketingPhoneAfter', data.enabled)
		// 	)
		// 	permissionGroupList[1].preferenceList.filter(preference => preference.name === 'Door to door').map((data) =>
		// 		bodyFormData.append('allowMarketingFotsAfter', data.enabled)
		// 	)
		// 	permissionGroupList[1].preferenceList.filter(preference => preference.name === 'Direct mail').map((data) =>
		// 		bodyFormData.append('allowMarketingMailAfter', data.enabled)
		// 	)
		// } else {//after market preference
		// 	bodyFormData.append('allowMarketingEmailAfter', false);
		// 	bodyFormData.append('allowMarketingSmsAfter', false);
		// 	bodyFormData.append('allowMarketingPhoneAfter', false);
		// 	bodyFormData.append('allowMarketingFotsAfter', false);
		// 	bodyFormData.append('allowMarketingMailAfter', false);
		// }
		//same value for 3rd party as only one flag is there.
		// if (data.permissionGroupList) {
		// 	bodyFormData.append('disallowThirdPartyMarketing', permissionGroupList[2].enabled);
		// 	bodyFormData.append('disallowThirdPartyMarketingAfter', permissionGroupList[2].enabled);
		// }
		// else {
		// 	bodyFormData.append('disallowThirdPartyMarketing', false);
		// 	bodyFormData.append('disallowThirdPartyMarketingAfter', false);
		// }


		if (localStorage.getItem('eir_be_data') && mailConfirmation) {
			bodyFormData.append('orderId', JSON.parse(localStorage.getItem('eir_be_data')).order.id);
			/**************/
			try {
				let urlPath = '/store/api/checkout/customer-details/';
				let res = await axios({
					method: 'POST',
					url: urlPath,
					data: bodyFormData,
					headers: { 'Content-Type': 'multipart/form-data' },
				})
				if (res.status == 200) {
					if (res.data.success) {
						// if (data.permissionGroupList) {
						// 	sessionStorage.setItem('thirdPartyContact', permissionGroupList[2].enabled);//storing it for installation details page
						// }
						// else {
						// 	sessionStorage.setItem('thirdPartyContact', false);
						// }
						sessionStorage.setItem('thirdPartyContact', false);
						sessionStorage.setItem('custDob', data.date + '/' + data.month + '/' + data.year);//storing it for installation details page
						if (JSON.parse(localStorage.getItem("eir_be_data")).order.prequal && props.steps == 2) {//for all orders...except standalone
							saveInstallationDetails(data, bodyFormData);



						} else if (showEirCustomerMobileDetails || showSIMOMobileDetails) {
							setInstalltionAddress(bodyFormData);
							saveMobileDetails(data);

						}
						else {
							setActiveStep((prevActiveStep) => prevActiveStep + 1);
							setCustomerCheckoutActiveStep((prevActiveStep) => prevActiveStep + 1);
							setStepperClickable(true);
							setInstalltionAddress(bodyFormData);
						}
					} else {
						console.log(res.data.validationErrors[0].message);
					}
				} else {
					console.error(res.status);
				}
			}
			catch (err) {
				console.error(err);
			}
			/*************/
		}
	}
	async function saveInstallationDetails(data, custBodyFormData) {
		var bodyFormData = new FormData();
		bodyFormData.append('masterSocket', 'yes');
		bodyFormData.append('installationTypePreference', 'SELF_INSTALL');
		/*******/
		// var county = (custBodyFormData.get('billingAddress.county') ? custBodyFormData.get('billingAddress.county') : '');
		// if (county != undefined && county != null) {
		// 	county = county.split('_')[1];
		// 	//console.log("county>>>11", county);
		// 	if (county == undefined) {
		// 		county = (custBodyFormData.get('billingAddress.county') ? custBodyFormData.get('billingAddress.county') : '');
		// 		county = county.split("_")[0];
		// 		//console.log("county>>>22", county);
		// 	}
		// 	//console.log("county>>>33", county);
		// }
		bodyFormData.append('installationAddress.address1', (custBodyFormData.get('billingAddress.address1') ? custBodyFormData.get('billingAddress.address1') : ''));
		bodyFormData.append('installationAddress.address2', (custBodyFormData.get('billingAddress.address2') ? custBodyFormData.get('billingAddress.address2') : ''));
		bodyFormData.append('installationAddress.address3', (custBodyFormData.get('billingAddress.address3') ? custBodyFormData.get('billingAddress.address3') : ''));
		bodyFormData.append('installationAddress.county',custBodyFormData.get('billingAddress.county') ? getCounty(custBodyFormData.get('billingAddress.county')) : '');
		bodyFormData.append('installationAddress.town', (custBodyFormData.get('billingAddress.town') ? custBodyFormData.get('billingAddress.town') : ''));
		bodyFormData.append('installationAddress.eircode', (custBodyFormData.get('billingAddress.eircode') ? custBodyFormData.get('billingAddress.eircode') : ''));
		bodyFormData.append('securityQuestion', 'Name a memorable date');//default value
		bodyFormData.append('securityAnswer', sessionStorage.getItem('custDob'));//default value
		bodyFormData.append('billDeliveryMethod', 'ONLINE_ONLY');//default value
		bodyFormData.append('isLandlineDirectoryListing', false);//default value
		if (localStorage.getItem('eir_be_data')) {
			bodyFormData.append('orderId', JSON.parse(localStorage.getItem('eir_be_data')).order.id);
		}
		try {
			let urlPath = '/store/api/checkout/service-details/';
			let res = await axios({
				method: 'POST',
				url: urlPath,
				data: bodyFormData,
				headers: { 'Content-Type': 'multipart/form-data' },
			})
			if (res.status == 200) {
				if (res.data.success) {
					// setActiveStep((prevActiveStep) => prevActiveStep + 1);
					// setCustomerCheckoutActiveStep((prevActiveStep) => prevActiveStep + 1);
					// setStepperClickable(true);
					if (showEirCustomerMobileDetails || showSIMOMobileDetails) {
						saveMobileDetails(data);
					}
					else {
						getMoveNext();
					}

				} else {
					console.log(res.data.success);
				}
			} else {
				console.log(res.data.validationErrors[0].message);
			}
		}
		catch (err) {
			console.error(err);
		}
	}
	async function saveMobileDetails(data) {
		//console.log('DATA with mobile details>>>', data);
		var bodyFormData = new FormData();

		/*****************/
		if (data.keepMobileNumber && data.keepMobileNumber === 'true')
			bodyFormData.append('mobilePortingDtos[0].keepNumber', true);
		else
			bodyFormData.append('mobilePortingDtos[0].keepNumber', false);
		bodyFormData.append('mobileNumberPPUpg', '');

		if (data.custMobilePrefix)
			bodyFormData.append('mobilePortingDtos[0].existingNumberPrefix', data.custMobilePrefix);

		if (data.custMobileEirPhoneNo)
			bodyFormData.append('mobilePortingDtos[0].existingNumber', data.custMobileEirPhoneNo);
		else
			bodyFormData.append('mobilePortingDtos[0].existingNumber', '');

		if (data.custMobileNetworkProvider)
			bodyFormData.append('mobilePortingDtos[0].existingProvider', data.custMobileNetworkProvider);

		bodyFormData.append('mobilePortingDtos[0].mobileId', JSON.parse(localStorage.getItem("eir_be_data")).order.bundle && JSON.parse(localStorage.getItem("eir_be_data")).order.bundle.mobiles[0].id);

		if (data.custMobilePaymentType)
			bodyFormData.append('mobilePortingDtos[0].existingPlanType', data.custMobilePaymentType);
		if (data.custMobilePaymentType && data.custMobilePaymentType === "BILLPAY") {
			bodyFormData.append('mobilePortingDtos[0].existingAccountNumber', data.custMobileEirAccountNo);
			bodyFormData.append('mobilePortingDtos[0].multipleMobileOnAccount', data.onlyAccountNumber);
		}
		else {
			if (data.registeredMobileNetwork)
				bodyFormData.append('mobilePortingDtos[0].existingRegisteredPrepay', data.registeredMobileNetwork)
			if (data.onlyAccountNumber) {
				bodyFormData.append('mobilePortingDtos[0].multipleMobileOnAccount', data.onlyAccountNumber);
			}
		}
		if (data.mobileDirectoryEnquiry)
			bodyFormData.append('mobilePortingDtos[0].MobileDirectoryListing', data.mobileDirectoryEnquiry);
		else
			bodyFormData.append('mobilePortingDtos[0].MobileDirectoryListing', false);

		if (localStorage.getItem('eir_be_data')) {
			bodyFormData.append('orderId', JSON.parse(localStorage.getItem('eir_be_data')).order.id);
		}

		try {

			let urlPath = '/store/api/checkout/mobile-details';

			let res = await axios({
				method: 'POST',
				url: urlPath,
				data: bodyFormData,
				headers: { 'Content-Type': 'multipart/form-data' },
			})
			//console.log("s15");
			if (res.status == 200) {
				if (res.data.success) {
					// setActiveStep((prevActiveStep) => prevActiveStep + 1);
					// setCustomerCheckoutActiveStep((prevActiveStep) => prevActiveStep + 1);
					// setStepperClickable(true);

					getMoveNext();

				} else {
					console.log(res.data.success);
				}
			} else {
				console.log(res.data.validationErrors[0].message);
			}
		}
		catch (err) {
			console.error(err);
		}
		/*****************/
	}
	const getMoveNext = () => {
		setActiveStep((prevActiveStep) => prevActiveStep + 1);
		setCustomerCheckoutActiveStep((prevActiveStep) => prevActiveStep + 1);
		setStepperClickable(true);
	}
	const getCounty = (county) => {
		var countyArr=county.split('_');
		if(countyArr.length===1)
			return countyArr[0];
		if(countyArr.length>1)
			return countyArr[1]; 
	}
	const [showBank, setShowBank] = useState(true);
	const [showSupplier, setShowSupplier] = useState(true);
	const [showProof, setShowProof] = useState(true);
	const [showAccountInfo, setShowAccountInfo] = useState(false);
	const customerCheckoutActiveStep = props.customerCheckoutActiveStep;
	const [loginSuccess, setLoginSuccess] = useState(false);
	const [broadBandTypeFTH, setBroadBandTypeFTH] = useState(false);
	const [eirCode, setEirCode] = useState(null);
	const [showPersonalInfo, setShowPersonalInfo] = useState(true);

	useEffect(() => {
		setActiveStep(0);
		if (localStorage.getItem("eir_be_data")) {
			if (JSON.parse(localStorage.getItem("eir_be_data")).order.prequal) {
				if (JSON.parse(localStorage.getItem("eir_be_data")).order.prequal.customerType != 'NEW') {
					setShowAccountInfo(true); // added to show account details component for existing user.
					let bundle = JSON.parse(localStorage.getItem("eir_be_data")).order.bundle;
					if (bundle.broadband || (bundle.broadband && bundle.tv)) {
						//console.log('LINE 200');
						setShowSupplier(false);
						setShowProof(false);
						setShowBank(true);
					}
					if ((bundle.broadband && bundle.mobiles.length > 0) || (bundle.broadband && bundle.mobiles.length > 0 && bundle.tv)) {
						//console.log('LINE 205');
						setShowSupplier(false);
						setShowProof(true);
						setShowBank(true);
					}
				} else {	//new customer			
					let bundle = JSON.parse(localStorage.getItem("eir_be_data")).order.bundle;
					if (bundle.broadband || (bundle.broadband && bundle.tv)) {
						//console.log('LINE 209');
						setShowSupplier(true);
						setShowProof(false);
						setShowBank(true);
					}
					if ((bundle.broadband && bundle.mobiles.length > 0) || (bundle.broadband && bundle.mobiles.length > 0 && bundle.tv)) {
						//console.log('LINE 215');
						setShowSupplier(true);
						setShowProof(true);
						setShowBank(true);
					}
				}
			} else {//for stand alone journey
				if (JSON.parse(localStorage.getItem("eir_be_data")).order.bundle && JSON.parse(localStorage.getItem("eir_be_data")).order.bundle.standaloneMobile && (localStorage.getItem("global_customer_type")) != 'new') {
					setShowAccountInfo(true);
				}
				if (JSON.parse(localStorage.getItem("eir_be_data")).order.bundle && JSON.parse(localStorage.getItem("eir_be_data")).order.bundle.mobiles.length>0 && JSON.parse(localStorage.getItem("eir_be_data")).order.bundle.mobiles[0].customerType=='NEW') {
					setShowAccountInfo(false);// if not selected default is new
				}
				if (localStorage.getItem("global_customer_type") && localStorage.getItem("global_customer_type")==='existing' &&  JSON.parse(localStorage.getItem("eir_be_data")).order.bundle && JSON.parse(localStorage.getItem("eir_be_data")).order.bundle.mobiles && JSON.parse(localStorage.getItem("eir_be_data")).order.bundle.mobiles.length>0) {
					setShowAccountInfo(true);// if selected default is existing
				}
				setShowSupplier(false);
				setShowProof(true);
				setShowBank(true);
			}
		}
		if (JSON.parse(localStorage.getItem("eir_be_data")).order.bundle && JSON.parse(localStorage.getItem("eir_be_data")).order.bundle.mobiles.length > 0 && JSON.parse(localStorage.getItem("eir_be_data")).order.bundle.mobiles[0].mobileOrderType === 'PORT') {
			setShowEirCustomerMobileDetails(true);
		} else {
			setShowEirCustomerMobileDetails(false);
		}
		/*********SIMO check************/
		if (JSON.parse(localStorage.getItem("eir_be_data")).order.bundle && JSON.parse(localStorage.getItem("eir_be_data")).order.bundle.mobiles.length > 0 && JSON.parse(localStorage.getItem("eir_be_data")).order.bundle.mobiles[0].simOnly == true) {
			setShowSIMOMobileDetails(true);
			setSIMOName(JSON.parse(localStorage.getItem("eir_be_data")).order.bundle.mobiles.length > 0 && JSON.parse(localStorage.getItem("eir_be_data")).order.bundle.mobiles[0].plan.name);
		} else {
			setShowSIMOMobileDetails(false);
		}
		/********************/
		/*****check EIRCODE availibility******/
		if (JSON.parse(localStorage.getItem("eir_be_data")).order.prequal && (JSON.parse(localStorage.getItem("eir_be_data")).order.prequal.eircode)) {
			setEirCode(JSON.parse(localStorage.getItem("eir_be_data")).order.prequal.eircode);
		}
		/************************************/
		if (localStorage.getItem("eir_be_data")) {
			let order = JSON.parse(localStorage.getItem('eir_be_data')).order;
			if (order.bundle && order.bundle.broadband && order.bundle.broadband.plan ) {//broadbandType FTH checking
				if(order.bundle.broadband.plan.type === 'FTH' || order.bundle.broadband.plan.type === 'NBI') {
					setBroadBandTypeFTH(true);
				}     
			}
		}
		////Hiding PersonalInfo and mraketing preferences for Existing customers///////
		if (localStorage.getItem("eir_be_data")) {
			if (JSON.parse(localStorage.getItem("eir_be_data")).order.prequal) {
				if (JSON.parse(localStorage.getItem("eir_be_data")).order.prequal.customerType != 'NEW') {
					setShowPersonalInfo(false);
				}
			}
			else if ((JSON.parse(localStorage.getItem("eir_be_data")).order.bundle) && (JSON.parse(localStorage.getItem("eir_be_data")).order.bundle.standaloneMobile) && (localStorage.getItem("global_customer_type") != 'new')) {
				setShowPersonalInfo(false);
			}
			if ((localStorage.getItem("global_customer_type") === null) && 
        	(JSON.parse(localStorage.getItem("eir_be_data")).order.bundle) &&
			(JSON.parse(localStorage.getItem("eir_be_data")).order.bundle.standaloneMobile) &&
			JSON.parse(localStorage.getItem("eir_be_data")).order.bundle.mobiles.length > 0 &&
			JSON.parse(localStorage.getItem("eir_be_data")).order.bundle.mobiles[0].customerType ==='NEW') {
				setShowPersonalInfo(true);
			}   
		}

	}, [customerCheckoutActiveStep, mailConfirmation]);
	const setCustomerCheckoutActiveStep = function (index) {
		props.setCustomerCheckoutActiveStep(index);
	}
	const methods = useForm(
		{
			mode: 'onChange',
			defaultValues: {},
		}
	);

	const defaultTheme = createMuiTheme();
	const ColorlibConnector = withStyles({
		alternativeLabel: {
			top: (isMobileOnly) ? 22 : 16,
		},
		alternativeLabel: {
			top: 22,
			[defaultTheme.breakpoints.down(768)]: {
				top: 16,
				left: -50,
			}
		},
		active: {
			'& $line': {
				backgroundImage:
					'linear-gradient( 95deg,rgba(148,62,169,255) 0%,rgba(174,53,184,255) 50%,rgba(210,39,204,255) 100%)',
			},
		},
		completed: {
			'& $line': {
				backgroundImage:
					'linear-gradient( 95deg,rgba(148,62,169,255) 0%,rgba(174,53,184,255) 50%,rgba(210,39,204,255) 100%)',
			},
		},
		line: {
			height: '0.15rem',
			border: 0,
			backgroundColor: '#eaeaf0',
			borderRadius: 1,
			width: 96,
			margin: '0 auto',
		},
	})(StepConnector);

	const useColorlibStepIconStyles = makeStyles({
		root: {
			backgroundColor: '#ccc',
			zIndex: 1,
			color: '#fff',
			width: 40,
			height: 40,
			display: 'flex',
			borderRadius: '50%',
			justifyContent: 'center',
			alignItems: 'center',
		},
		active: {
			boxShadow: '0 4px 10px 0 rgba(0,0,0,.25)',
			backgroundSize: 100,
			background: 'linear-gradient(180deg, #892BA0 0%, #470A68 100%);',
		},
		completed: {
			background: 'linear-gradient(180deg, #892BA0 0%, #470A68 100%);',
		},
		'& .stepperIcon': {
			marginTop: '-1.4rem',
			marginLeft: '.4rem',
			height: 13,
			width: 7,
		},
	});

	function ColorlibStepIcon(props) {
		const classes = useColorlibStepIconStyles();
		const { active, completed } = props;

		const icons = {
			1: <Icon><img className="stepperIcon1" src={'/.galleries/checkout/1.png'} height={25} width={25} /></Icon>,
			2: <Icon><img className="stepperIcon2" src={'/.galleries/checkout/2.png'} height={25} width={25} /></Icon>,
			3: <Icon><img className="stepperIcon3" src={'/.galleries/checkout/3.png'} height={25} width={25} /></Icon>,
		};

		return (
			<div
				className={clsx(classes.root, {
					[classes.active]: active,
					[classes.completed]: completed,
				})}
			>
				{icons[String(props.icon)]}
			</div>
		);
	}

	const [activeStep, setActiveStep] = React.useState(1);
	const steps = getSteps();
	const [stepperClickable, setStepperClickable] = useState(false);
	const stepperClickablefromID = props.stepperClickablefromID;
	const handleBack = () => {
		if (activeStep !== 0) {
			setActiveStep((prevActiveStep) => prevActiveStep - 1);
			setCustomerCheckoutActiveStep((prevActiveStep) => prevActiveStep - 1);
		}
	};
	function getSteps() {
		if (JSON.parse(localStorage.getItem("eir_be_data"))) {
			if (JSON.parse(localStorage.getItem("eir_be_data")).order.prequal) {//checking for general order
				if (JSON.parse(localStorage.getItem("eir_be_data")).order.prequal.customerType == "NEW") {
					if (isMobileOnly) {
						return ['Customer', 'Installation', 'Payment'];
					}
					else {
						return ['Customer Details', 'Installation Details', 'Payment Details'];
					}
				}
				else if (JSON.parse(localStorage.getItem("eir_be_data")).order.prequal.customerType == JSON.parse(localStorage.getItem("eir_be_data")).order.bundle.broadband.plan.type) {
					if (isMobileOnly) {
						return ['Customer', 'Payment'];
					}
					else {
						return ['Customer Details', 'Payment Details'];
					}
				}
				else {
					if (isMobileOnly) {
						return ['Customer', 'Installation', 'Payment'];
					}
					else {
						return ['Customer Details', 'Installation Details', 'Payment Details'];
					}
				}
			} else {//for stand alone journey as there is no prequal data
				if (isMobileOnly) {
					return ['Customer', 'Payment'];
				}
				else {
					return ['Customer Details', 'Payment Details'];
				}
			}
		}
	}
	const handleStep = (step) => () => {
		// stepper should be clickable only when all details are filled
		if (stepperClickable) {
			if (step > 1) {
				if (stepperClickablefromID) {
					setActiveStep(step);
					setCustomerCheckoutActiveStep(step);
				}
			}
			else {
				setActiveStep(step);
				setCustomerCheckoutActiveStep(step);
			}
		}
	};
	// login
	const [modal, setModal] = useState(false);

	const handleToggle = () => {
		setModal(!modal);
	}
	const setInstalltionAddress = (bodyFormData) => {
		let insAdd = [];
		insAdd.push({
			'eircode': (bodyFormData.get('billingAddress.eircode') ? bodyFormData.get('billingAddress.eircode') : ''),
			'address1': (bodyFormData.get('billingAddress.address1') ? bodyFormData.get('billingAddress.address1') : ''),
			'address2': (bodyFormData.get('billingAddress.address2') ? bodyFormData.get('billingAddress.address2') : ''),
			'address3': (bodyFormData.get('billingAddress.address3') ? bodyFormData.get('billingAddress.address3') : ''),
			'town': (bodyFormData.get('billingAddress.town') ? bodyFormData.get('billingAddress.town') : ''),
			'county': (bodyFormData.get('billingAddress.county') ? getCounty(bodyFormData.get('billingAddress.county')) : '')
		});
		sessionStorage.setItem('insAdd', JSON.stringify(insAdd));//storing it in session storage
		//console.log('insAdd getItem>>>>>>>', JSON.parse(sessionStorage.getItem('insAdd')));
	};
	return (
		<Fragment>
			<ThemeProvider theme={theme}>
				<FormContext {...methods}>
					{/* Start Stepper Zone */}
					<Grid>
						<Paper elevation={3} className={classes.paper}>
							<div className={classes.root + " container"}>
								<a href="/checkout/order-summary/" onClick={handleBack} className={" float-left checkoutStep_back "}>
									Back
								</a>
								<Grid item xs={12} id="customer_checkout_container">
									<Box display={{ xs: 'none', md: 'block' }} >
										<Stepper activeStep={activeStep} connector={<ColorlibConnector />}>
											{(steps) && steps.map((label, index) => (
												<Step key={label}>
													<StepLabel onClick={handleStep(index)} StepIconComponent={ColorlibStepIcon} >{label}</StepLabel>
												</Step>
											))}
										</Stepper>
									</Box>
									<Box display={{ xs: 'block', md: 'none' }}>
										<Stepper alternativeLabel activeStep={activeStep} connector={<ColorlibConnector />}>
											{(steps) && steps.map((label, index) => (
												<Step key={label} id={"step-" + index}>
													<StepLabel onClick={handleStep(index)} StepIconComponent={ColorlibStepIcon} >{label}</StepLabel>
												</Step>
											))}
										</Stepper>
									</Box>
								</Grid >
								<div class={" float-right checkoutStep_next "} onClick={methods.handleSubmit(onSubmit)}>
									Next
								</div>
							</div >
						</Paper>
					</Grid>
					{/* END Stepper Zone */}
					<Grid>
						<Grid container className={classes.mainContainer}>
							<Grid container sm={12}>
								<Grid container sm={12} className={classes.pageTitlePadding}>
									<Grid item sm={7}>
										<h1 className={classes.titleText}>Customer Details</h1>
									</Grid>
									<Grid item sm={1}>
										{/* <Typography className={classes.loginLink}>Log in</Typography> */}
									</Grid>
									<Grid item sm={4}>
										<Typography className={classes.loginText}>Already a Customer? <a type href="#" onClick={handleToggle} title="Login with my eir" className={classes.loginLink}>Login with my eir</a></Typography>
									</Grid>
								</Grid>
								<Grid item sm={12} className={classes.titlePadding}>
									<h2 className={classes.pageTitle}>You’ll need the following details to continue:</h2>
								</Grid>
								<Grid container sm={12} xs={12} >
									{showBank ?
										<Grid container sm={4}>
											<Grid item sm={2} xs={2} className={classes.dataOptionBackground}>
												<img src="/.galleries/checkout/bank.png" className={classes.iconBankPosition} />
											</Grid>
											<Grid container sm={10} xs={9}
												className={classes.loginTitleBottomPadding}
											>
												<Grid item sm={12} >
													<h4 className={classes.loginTitle}>Bank Details</h4>
												</Grid>
												<Grid item sm={12}>
													<Typography className={(!showSupplier && !showProof) ? classes.loginBankSingleSubTitle : classes.loginBankSubTitle}>You will need your IBAN and BIC (or your account number and sort code)</Typography>
												</Grid>
											</Grid>
										</Grid>
										: ""}
									{showSupplier ?
										<Grid container sm={4}>
											<Grid item sm={2} xs={2} className={classes.dataOptionBackground}>
												<img src="/.galleries/checkout/supplier.png" className={classes.iconSupplierPosition} />
											</Grid>
											<Grid container sm={10} xs={9}
												className={classes.loginTitleBottomPadding}
											>
												<Grid item sm={12}>
													<h4 className={classes.loginTitle}>Current Supplier</h4>
												</Grid>
												<Grid item sm={12}>
													<Typography className={classes.loginSubTitle}>If you currently have a landline or broadband, you will need to have your account number(s) to hand.</Typography>
												</Grid>
											</Grid>
										</Grid>
										: ""}
									{showProof ?
										<Grid container sm={4}>
											<Grid item sm={2} xs={2} className={classes.dataOptionBackground}>
												<img src="/.galleries/checkout/user.png" className={classes.iconPosition} />
											</Grid>
											<Grid container sm={10} xs={9}>
												<Grid item sm={12}>
													<h4 className={classes.loginTitle}>Proof of ID</h4>
												</Grid>
												<Grid item sm={12}>
													<Typography className={classes.loginSubTitle}>You’ll need the ID number of your driving license, passport or other valid European ID document.</Typography>
												</Grid>
											</Grid>
										</Grid>
										: ""}

								</Grid>
							</Grid>
							<Grid item sm={12}>
								<form>
									{showAccountInfo ? <EirCustomerAccountDetails loginSuccess={loginSuccess}></EirCustomerAccountDetails> : ''}
									<EirContactDetails loginSuccess={loginSuccess} mailConfirmation={mailConfirmation}></EirContactDetails>
									<EirCustomerAddress
										eirCode={eirCode}
										broadBandTypeFTH={broadBandTypeFTH} />
									<EirPersonalInformation
										showProof={showProof}
										showPersonalInfo={showPersonalInfo}
									></EirPersonalInformation>
									{showEirCustomerMobileDetails || showSIMOMobileDetails ? <EirCustomerMobileDetails
										showEirCustomerMobileDetails={showEirCustomerMobileDetails}
										showSIMOMobileDetails={showSIMOMobileDetails}
										SIMOName={SIMOName}
									/> : ''}
									{showPersonalInfo ?
										<EirCustomerMarketingPreferences></EirCustomerMarketingPreferences>
										: ''}

									<div className="bottom_Buttons">
										<div
											onClick={(event) => { props.handleBack(event) }}
											className={'float-left bottom_stepBack'}>
											Back</div>
										<Button className={classes.btnNextStepper} onClick={methods.handleSubmit(onSubmit)} >Step {props.customerCheckoutActiveStep + 2}: {props.BottomNextText}</Button>
									</div>
								</form>
							</Grid>
						</Grid>
						{modal &&
							<Modal className={" LoginModal  modalDialog paymentEirLogin"} centered={true} isOpen={modal} toggle={handleToggle} >
								<ModalBody className={"modalContent "}>
									<img onClick={handleToggle} src={'/.galleries/eir/icons/plus-circle.png'} alt="Close" className={"phonedetails-close-icon"} />
									<EirLogin
										toggle={handleToggle}
										setLoginSuccess={setLoginSuccess}
									>
									</EirLogin>
								</ModalBody>
							</Modal>
						}
					</Grid>
				</FormContext>
			</ThemeProvider>
		</Fragment>
	);
}